import { Permission, PermissionsAndroid, Rationale } from 'react-native';
import { useMutation, useQuery, useQueryClient } from 'react-query';

interface Params {
  permission: Permission;
  rationale?: Rationale;
}

export const usePermission = ({ permission, rationale }: Params) => {
  const key = ['permission', permission];
  const query_client = useQueryClient();

  const { data: granted } = useQuery(key, async () => {
    return await PermissionsAndroid.check(permission);
  });

  const request = useMutation(
    async () => {
      const status = await PermissionsAndroid.request(permission, rationale);

      return status === PermissionsAndroid.RESULTS.GRANTED;
    },
    {
      onSuccess() {
        query_client.invalidateQueries(key);
      },
    }
  );

  return {
    granted,
    request,
  };
};
